import { Entry } from '../Entry'

export function Entry20251126() {
  return (
    <Entry title="2025 Nov 26 - v3.11.3">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/20273/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
